module.exports = __webpack_public_path__ + "static/img/1-1Z524145923361.601d984.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1-1Z524145923361.jpg
// module id = Ha5Z
// module chunks = 0